/**
 * Format a timestamp as relative time in French
 * Examples: "il y a 3 minutes", "il y a 2 heures", "il y a 1 jour"
 */
export function formatRelativeTime(timestamp: string | null): string {
  if (!timestamp) {
    return 'Inconnu';
  }

  const now = new Date();
  const past = new Date(timestamp);
  const diffMs = now.getTime() - past.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);

  // Less than a minute
  if (diffSeconds < 60) {
    return 'il y a quelques secondes';
  }

  // Less than an hour
  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return diffMinutes === 1
      ? 'il y a 1 minute'
      : `il y a ${diffMinutes} minutes`;
  }

  // Less than a day
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return diffHours === 1
      ? 'il y a 1 heure'
      : `il y a ${diffHours} heures`;
  }

  // Days
  const diffDays = Math.floor(diffHours / 24);
  return diffDays === 1
    ? 'il y a 1 jour'
    : `il y a ${diffDays} jours`;
}

/**
 * Format next sync time as HH:MM
 * Example: "18:30"
 */
export function formatNextSyncTime(timestamp: string | null): string {
  if (!timestamp) {
    return '--:--';
  }

  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}
